export default __webpack_public_path__ + "379766df6d9620c8f7e0bcc39c6905e2.jpg";